import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=5971995b&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5971995b')) {
      api.createRecord('5971995b', component.options)
    } else {
      api.reload('5971995b', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=5971995b&", function () {
      api.rerender('5971995b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gpx4je7FWs50/JS/offershelp.vue"
export default component.exports